import { Download, Copy, AlertCircle } from 'lucide-react';
import OfficeActionAnalysisDisplay from './OfficeActionAnalysisDisplay';

interface OAAnalyzeDisplayProps {
  result: any;
  theme?: 'light' | 'dark';
  showToast?: (message: string) => void;
  addToResources?: (resource: any) => void;
  showHeader?: boolean;
  contextData?: any;
  onAddToInput?: (text: string) => void;
  onCopyResult?: () => void;
}

export default function OAAnalyzeDisplay({
  result,
  theme = 'light',
  showToast,
  addToResources,
  showHeader = true,
  contextData = {},
  onAddToInput,
  onCopyResult
}: OAAnalyzeDisplayProps) {
  // Use the full-featured OfficeActionAnalysisDisplay component
  return (
    <OfficeActionAnalysisDisplay
      result={result}
      theme={theme}
      showToast={showToast}
      addToResources={addToResources}
      showToggle={showHeader}
      contextData={contextData}
      onAddToInput={onAddToInput}
      onCopyResult={onCopyResult}
    />
  );
}
